import { useState } from "react";
import { Link } from "react-router-dom";
import rptIcon from "../../assets/images/menu-icon-5.svg";
import icon2 from "../../assets/images/menu-icon-2.svg";
import icon5 from "../../assets/images/menu-icon-5.svg";



const VerticalMenu = () => {
  // Complience Active  blade
  const [showComplianceActivity, setShowComplianceActivity] = useState(false);
  const handleCloseComplianceActivity = () => setShowComplianceActivity(false);
  const handleShowComplianceActivity = () => setShowComplianceActivity(true);

  // Complience Report  blade
  const [showFlagginReport, setShowFlagginReport] = useState(false);
  const handleCloseFlagginReport = () => setShowFlagginReport(false);
  const handleShowFlagginReport = () => setShowFlagginReport(true);

  function toggleLeftMenu() {
    var element: any = document.getElementById("vertical_menu");
    element.classList.toggle("open-menu");
  }
  return (
    <>
      {localStorage.getItem("user_type") === "FRANCHISEE" ? (
        <div id="vertical_menu" className="verticle-menu">
          <div className="menu-list">
            <Link id="t-1" to={"/home"} className="menu-item" onClick={toggleLeftMenu}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width=" "
                height=" "
                fill="currentColor"
                className="bi bi-house menu-icon"
                viewBox="0 0 16 16"
              >
                <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z" />
              </svg>
              <span className="nav-text">Home</span>
            </Link>
            <Link id="t-1" to={"/signup"} className="menu-item" onClick={toggleLeftMenu}>
              {" "}
              <img src={icon2} alt="icon" className="menu-icon" />{" "}
              <span className="nav-text">Signup</span>
            </Link>
            <Link id="t-1" to={"/stocks"} className="menu-item" onClick={toggleLeftMenu}>
              {" "}
              <img src={icon5} alt="icon" className="menu-icon" />{" "}
              <span className="nav-text">Stocks</span>
            </Link>
          </div>
        </div>
      ) : (
        ""
      )}

      {localStorage.getItem("user_type") === "STOCKIST" ? (
        <div id="vertical_menu" className="verticle-menu">
          <div className="menu-list">
            <Link id="t-1"   to={"/stockist-report"} className="menu-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width=" "
                height=" "
                fill="currentColor"
                className="bi bi-house menu-icon"
                viewBox="0 0 16 16"
              >
                <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z" />
              </svg>
              <span className="nav-text">Home</span>
            </Link>
            <Link id="t-1" to={"/home"} className="menu-item">
              {" "}
              <img src={rptIcon} alt="icon" className="menu-icon" />{" "}
              <span className="nav-text">Report</span>
            </Link>
          </div>
        </div>
      ) : (
        ""
      )}

    </>
  );
};
export default VerticalMenu;
